/**
 *	scripts/Hero-Component.js
 */

window.heroComponent = function () {
  const arrow = document.querySelector('.Hero-Component .arrow');
  const content = document.querySelector('.Homepage-Component');

  arrow.addEventListener('click', function () {
    content.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  });
};
